import React from "react";
import PropTypes from "prop-types";
import { t } from "i18next";
import Slider from "Components/slider/Slider";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import WarningBanner from "Components/warningBanner/WarningBanner";
import s from "./retentionEmailAccounts.scss";

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isLoggedUserTrial: PropTypes.func,
};

class Retention extends React.Component {
  componentWillUnmount() {
    this.props.resetFields(["retention"]);
  }

  render() {
    const { formData, setFormFieldValue, isFormLoading, submitForm } = this.props;

    return (
      <form className={s.retentionEmailAccount} method="post" onSubmit={submitForm}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine("retention") && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}
          </div>
          <div className={s.infoBtnGroup}>
            <Button docsKey="archive_emailAccount_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>
        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.archive.retention.title")}</div>
              <div className="sectionDesc">{t("settings.sections.archive.retention.desc.emailAccount")}</div>
            </div>
            <div className="formsSectionSP">
              <Slider
                className="inputFull2"
                label={t("input.label.retention")}
                onChange={setFormFieldValue}
                name="retention"
                value={formData.retention}
                hint={<TranslatedString>input.hint.archive.retention</TranslatedString>}
                min={1}
                max={10}
                marks={{
                  1: 1,
                  2: 2,
                  3: 3,
                  4: 4,
                  5: 5,
                  6: 6,
                  7: 7,
                  8: 8,
                  9: 9,
                  10: 10,
                }}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

Retention.contextTypes = ContextTypes;

export default Retention;
